import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AirlineService } from '../../../services/airline.service';
import { Airline } from '../../../models/airlines-model';
import { AuthenticationService } from '../../../services/authentication.service';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { CommonFunction } from '../../../common/common-functions';
import { TermsConditions } from '../../../models/airlines-model';

@Component({
  selector: 'ngx-modal-content',
  templateUrl: './termsconditions.component.html',
  styleUrls: ['./termsconditions.component.css'] // Optional: For custom styling
})
export class TermsConditionsComponent implements OnInit {
  TermsConditions: FormGroup;
  termId: number ;
  content: string;
  submitted = false;
  loading = false;
  isDesabled=false; 


  constructor( private _airlineService:AirlineService,private formBuilder: FormBuilder,
    private _router: Router,
    private _auth: AuthenticationService,
    private commservice:CommonService,
    private commonfunction:CommonFunction
    
  ) {}

  ngOnInit(): void {

    this.TermsConditions = this.formBuilder.group({
      Content: ['', Validators.required],
      TermId: ['', Validators.required],
    });
    this.getTermConditions();
    
  }

  get f() {
    return this.TermsConditions.controls;
  }
  // get terms and conditions
  getTermConditions(): void {
    this._airlineService.gettermsconditions().subscribe(
      (data) => {
        if (!data['isError'] && data['code'] === 200) {
           
          const terms = data['payload'][0];
          //const term = data['payload'][1];
          this.content = terms.content;
         this.termId = terms.termId; 
          this.TermsConditions.patchValue({
            Content: this.content ,
            TermId: this.termId  
                 
          });
           
        }
      },
      (error) => {
        console.error('Error fetching terms and conditions:', error);
      }
    );
}

onSubmit(): void {
  this.submitted = true;
  if(this.TermsConditions.valid){
    this.isDesabled=true;
    const termsconditions=new TermsConditions();
    termsconditions.CreatedBy=this._auth.getUserId()
    termsconditions.Content=this.TermsConditions.get('Content').value;
    this._airlineService.InsUpTermsConditions(termsconditions).subscribe(
      (data) => {
        if (data['isError'] === false && data['code'] === 200) {
          this.commonfunction.showToast('success', 'Success', 'Successfully saved');
        }
           else {
          this.commonfunction.showToast('danger', 'Failed', 'Not saved');
          this.isDesabled=false;
        }
      },
    );
  }

  if (this.TermsConditions.invalid) {
    return;
  }

  this.loading = true;

  setTimeout(() => {
    const formData = {
      content: this.TermsConditions.get('content')?.value,
    };

    this.loading = false;
    this._router.navigate(['/termCondition']);
  }, 200); 
}
}


